<form [formGroup]="formFilter" cForm class="container-filter">
  <mat-form-field>
    <mat-label>Busqueda</mat-label>
    <input id="inputGeneral"
      (keyup.enter)="filtroGeneral($event)"
      matInput
      formControlName="generalFilter"
      placeholder="Busqueda "
    />
  </mat-form-field>
  <!-- <mat-form-field>
    <mat-label>Pyme</mat-label>
    <mat-select (selectionChange)="changePymeSelect()" formControlName="pyme">
      <mat-option value="true">Si</mat-option>
      <mat-option value="false">No</mat-option>
      <mat-option value="nada">Todos</mat-option>
    </mat-select>  
  </mat-form-field> -->
  <mat-form-field>
    <mat-label>Clave SII</mat-label>
    <mat-select (selectionChange)="changeSiiSelect($event)" formControlName="sii">      
      <mat-option value="yes">Enrolado</mat-option>
      <mat-option value="no">No enrolado</mat-option>
      <mat-option value="all">Todos</mat-option>
    </mat-select>  
  </mat-form-field>

  <!--<mat-form-field>
    <mat-label>Elige el rango de dias</mat-label>
    <mat-date-range-input
      [formGroup]="formFilter"
      [rangePicker]="picker"
      format="dd/MM/YYYY"
      min='{{fechaMinBusqueda}}'
    >
      <input
        (keyup.enter)="filtrarPorFecha()"
        matStartDate
        formControlName="start"
        placeholder="Dia de Inicio"
      />
      <input
        (keyup.enter)="filtrarPorFecha()"
        matEndDate
        formControlName="end"
        placeholder="Dia de Termino"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Rango de Meses</mat-label>
    <mat-select #select formControlName="preference">
      <mat-option 
        (click)="filtroMeses(i.value)"
        *ngFor="let i of preferences"
        [value]="i.value"
      >
        {{ i.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

</form>
